import { createAsyncThunk } from '@reduxjs/toolkit';
import { FavoriteService } from '../../../epics/common/favorite';
import {
    clearGuestFavorites,
    getGuestFavorites,
} from '../../../../utils/common/guestFavorites';

export const addToFavorite = createAsyncThunk('addToFavorite', (advertId) => {
    return FavoriteService.addFavorite(advertId);
});

export const deleteFavorite = createAsyncThunk(
    'deleteFavorite',
    async (id, thunkAPI) => {
        try {
            const response = await FavoriteService.deleteFavorite(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const migrateGuestFavorites = createAsyncThunk(
    'migrateGuestFavorites',
    async () => {
        const items = getGuestFavorites();
        if (!items.length) return { migrated: 0 };
        const results = await Promise.allSettled(
            items.map((entry) => FavoriteService.addFavorite(entry.id)),
        );
        clearGuestFavorites();
        return {
            migrated: results.filter((r) => r.status === 'fulfilled').length,
        };
    },
);
